import { PropsWithChildren } from 'react';
import { DoqFaceSvgProps, DoqSize } from '../types';

const keyframes = `
@keyframes gone-doq-a0_t { 0% { transform: translate(0px,-131.3px); } 100% { transform: translate(0px,234.1px); } }
@keyframes gone-doq-a2_t { 0% { transform: translate(0px,-168px); } 100% { transform: translate(0px,237.7px); } }
`;

const GoneDoq = ({
  size,
  className,
  children,
  isAnimated,
}: PropsWithChildren<DoqFaceSvgProps>) => {
  const shouldBeAnimated =
    typeof isAnimated !== 'undefined' ? isAnimated : size === DoqSize.BIG;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 320 320"
      fill="none"
      className={className}
      role="presentation"
    >
      <style>{shouldBeAnimated ? keyframes : null}</style>
      <g clipPath="url(#clip0_1393_56132)">
        <circle cx="160" cy="160" r="160" fill="#A3CBF5" />
        <mask
          id="mask0_1393_56132"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="320"
          height="320"
        >
          <circle cx="160" cy="160" r="160" fill="#A3CBF5" />
        </mask>
        <g mask="url(#mask0_1393_56132)"></g>

        {/* Right cloud */}
        <path
          d="M313 130.8c0-0.1-23.5 .5-42.2-0.1c-18.6-0.5-14.5-25.1-2.3-24.8c.5-6.7 8.5-10.9 16-11.4c0-9.3 20.2-13.4 24.9 .5c4.1 1.6 9.1 3.1 8.5 10.6c12 0 13.2 24.9-4.9 25.1Z"
          fill="white"
          transform={
            shouldBeAnimated
              ? 'translate(292.4,-22.8) translate(-292.4,-108.5)'
              : ''
          }
          style={
            shouldBeAnimated
              ? { animation: '12s linear infinite both gone-doq-a0_t' }
              : {}
          }
        />

        {/* Left cloud */}
        <path
          d="M0 168c0 0 40.9 0 47-0.2c28.9-0.8 40.3-36.3 7.6-49.7c0-14.5-11.9-28.8-30.8-21.8c-5.4-15.5-23.8-14-23.8-14"
          fill="white"
          transform={
            shouldBeAnimated
              ? 'translate(37.2,-42.8) translate(-37.2,-125.2)'
              : ''
          }
          style={
            shouldBeAnimated
              ? { animation: '18s linear infinite both gone-doq-a2_t' }
              : {}
          }
        />

        {/* Wings of doqy */}
        <path
          d="M68.522 167.727C82.1228 147.469 109.601 142.128 129.8 155.816L108.278 187.873C94.6772 208.131 67.1992 213.472 47 199.784L68.522 167.727Z"
          fill="#F1F7FE"
        />
        <path
          d="M251.378 167.727C237.777 147.469 210.299 142.128 190.1 155.816L211.622 187.873C225.223 208.131 252.701 213.472 272.9 199.784L251.378 167.727Z"
          fill="#F1F7FE"
        />

        {/* White color of doqy */}
        <rect x="88" y="83" width="144" height="180" fill="white" />

        {/* Golden ring of doqy */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M160 112C175.702 112 190.017 108.879 200.48 103.741C210.812 98.6665 218 91.2786 218 82.5C218 73.7214 210.812 66.3336 200.48 61.2593C190.017 56.1212 175.702 53 160 53C144.298 53 129.984 56.1212 119.52 61.2593C109.188 66.3336 102 73.7214 102 82.5C102 91.2786 109.188 98.6665 119.52 103.741C129.984 108.879 144.298 112 160 112ZM209 82.5C209 84.9507 207.883 87.4393 205.548 89.8739C203.205 92.3185 199.718 94.6112 195.255 96.5801C186.335 100.515 173.872 103 160 103C146.128 103 133.665 100.515 124.745 96.5801C120.282 94.6112 116.795 92.3185 114.452 89.8739C112.117 87.4393 111 84.9507 111 82.5C111 80.0493 112.117 77.5607 114.452 75.1261C116.795 72.6815 120.282 70.3888 124.745 68.4199C133.665 64.4846 146.128 62 160 62C173.872 62 186.335 64.4846 195.255 68.4199C199.718 70.3888 203.205 72.6815 205.548 75.1261C207.883 77.5607 209 80.0493 209 82.5Z"
          fill="#FCB226"
        />
        {children}
      </g>
      <defs>
        <clipPath id="clip0_1393_56132">
          <rect width="320" height="320" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { GoneDoq };
